import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home.vue')
const Download = () => import('@/views/Download.vue')
const Jobs = () => import('@/views/Jobs.vue')
const Services = () => import('@/views/Services.vue')

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home, meta: { title: '连云港网 - www.lianyungang.com' } },
    { path: '/download', name: 'Download', component: Download, meta: { title: 'APP下载 - 连云港在线' } },
    { path: '/pc', name: 'PC', beforeEnter: () => window.open('https://www.lianyungang.com', '_blank') },
    { path: '/jobs', name: 'Jobs', component: Jobs, meta: { title: '招聘专区 - 连云港网' } },
    { path: '/services', name: 'Services', component: Services, meta: { title: '便民服务 - 连云港网' } },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) document.title = to.meta.title
  next()
})

export default router
